import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { getUser, logout } from "../lib/auth";

const linkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-1.5 rounded text-sm font-medium ${
    isActive
      ? "bg-slate-800 text-white"
      : "text-slate-700 hover:bg-slate-200"
  }`;

export function NavBar() {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    getUser().then((u) => {
      const claims = u?.profile as { email?: string } | undefined;
      setEmail(claims?.email ?? null);
    });
  }, []);

  return (
    <nav className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-2">
      <div className="flex items-center gap-2">
        <span className="text-lg font-semibold text-slate-800">Cockpit</span>
        <span className="text-xs text-slate-400">delivery</span>
        <div className="ml-6 flex gap-1">
          <NavLink to="/planner" className={linkClass}>
            Planner
          </NavLink>
          <NavLink to="/budget" className={linkClass}>
            Budget
          </NavLink>
        </div>
      </div>
      <div className="flex items-center gap-3 text-sm">
        {email && <span className="text-slate-500">{email}</span>}
        <button
          onClick={() => logout()}
          className="rounded border border-slate-300 px-2 py-1 text-slate-600 hover:bg-slate-100"
        >
          Sign out
        </button>
      </div>
    </nav>
  );
}
